<template>
  <footer class="site-footer">
    <div>Copyright Southwest Power Pool, Inc {{ thisYear() }} - All Rights Reserved</div>
    <a href="https://www.spp.org/terms-conditions/" target="_blank" rel="noopener">Terms &amp; Conditions</a>
    <a href="https://www.spp.org/contact-us/" target="_blank" rel="noopener">Contact Us</a>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
